<template>
  <div class="organization-risk-decision-view">
    <risk-rating-definition />
    <hr />

    <organization-risk-target-definition />

    <!-- Rating definition eklendikten sonra buna gerek kalmadığı düşünüldüğü için kapatıldı -->
    <!-- <risk-decision /> -->
  </div>
</template>

<script>
import RiskDecision from "./organization-risk-decision";
import RiskRatingDefinition from "./organization-risk-rating-definiton";
import OrganizationRiskTargetDefinition from "./organization-risk-target-definition";

export default {
  components: { RiskDecision, RiskRatingDefinition, OrganizationRiskTargetDefinition },
  data() {
    return {};
  },
  computed: {
    target() {
      return this.$store.getters["organizationRiskTarget/selectedEntity"];
    },
  },
  mounted() {
    this.fetchTarget();
  },
  methods: {
    fetchTarget() {
      this.$store.dispatch("organizationRiskTarget/fetchTarget");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./organization-risk-decision.scss";
</style>
